import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Generate random names for users
const ADJECTIVES = [
  'Happy', 'Clever', 'Brave', 'Bright', 'Swift', 'Kind', 'Wise', 'Cool', 'Bold', 'Calm',
  'Eager', 'Fair', 'Gentle', 'Jolly', 'Keen', 'Lively', 'Merry', 'Noble', 'Quick', 'Smart',
]

const NOUNS = [
  'Cat', 'Dog', 'Bird', 'Fish', 'Bear', 'Lion', 'Tiger', 'Wolf', 'Fox', 'Deer',
  'Owl', 'Eagle', 'Shark', 'Whale', 'Dolphin', 'Rabbit', 'Panda', 'Koala', 'Penguin', 'Turtle',
]

export function getRandomName(): string {
  const adjective = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)]
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)]
  return `${adjective}${noun}`
}

// Generate random ID
export function generateId(length: number = 4): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

// Convert seconds to time format
export function secondsToTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = Math.floor(seconds % 60)

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
  }
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
}

// Check if string is a valid URL
export function isUrl(string: string): boolean {
  try {
    const url = new URL(string)
    return !!url
  } catch {
    return false
  }
}

// Sanitize URL for shell usage
export function shellSanitizeUrl(url: string): string {
  return url.replace(/[;&|`$(){}[\]\\]/g, '\\$&')
}

// Get target time for video synchronization
export function getTargetTime(
  progress: number,
  lastSync: number,
  paused: boolean,
  playbackRate: number,
): number {
  if (paused) {
    return progress
  }
  const now = new Date().getTime() / 1000
  const timeDiff = now - lastSync
  return progress + (timeDiff * playbackRate)
}

// Check if video is in sync
export const SYNC_DELTA = 1.5 // seconds

export function isSync(
  currentTime: number,
  targetTime: number,
  lastSync: number,
  paused: boolean,
  playbackRate: number,
): boolean {
  if (paused) {
    return Math.abs(currentTime - targetTime) < SYNC_DELTA
  }

  const now = new Date().getTime() / 1000
  const expectedTime = targetTime + ((now - lastSync) * playbackRate)
  return Math.abs(currentTime - expectedTime) < SYNC_DELTA
}
